import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface WSTokenResponse {
  token_details?: {
    token: string;
    expires: number;
    issued: number;
    clientId: string;
  };
  messaging_backend?: "centrifugo";
}

export const useWSTokenRequest = () => {
  const userToken = useUserToken();
  return useQuery(
    [ENDPOINTS.ws_token_request, userToken],
    () =>
      fetch(ENDPOINTS.ws_token_request, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
    {
      enabled: !!userToken,
      refetchInterval: 600000, // 10 minutes
      staleTime: 600000, // 10 minutes
    },
  );
};
